import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  alpha,
  useTheme,
} from "@mui/material";
import {
  Close as CloseIcon,
  LogoutTwoTone as LogoutIcon,
} from "@mui/icons-material";

const LogoutConfirmDialog = ({ open, onClose, onConfirm }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 2,
          position: "relative",
          overflow: "hidden",
          backgroundColor: alpha(theme.palette.background.paper, 0.9),
          backdropFilter: "blur(16px)",
          boxShadow: theme.shadows[4],
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        },
      }}
    >
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.text.secondary,
        }}
      >
        <CloseIcon />
      </IconButton> */}

      <Box
        sx={{
          textAlign: "center",
          pt: 2,
          pb: 1,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            backgroundColor: alpha("#F97316", 0.1),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <LogoutIcon sx={{ fontSize: 32, color: "#F97316" }} />
        </Box>
        <DialogTitle sx={{ p: 0, mb: 1, fontWeight: 700, fontSize: "1.5rem" }}>
          Confirm Logout
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <DialogContentText sx={{ color: "text.secondary", fontSize: "1rem" }}>
            Are you sure you want to logout? You will need to login again to
            access your account.
          </DialogContentText>
        </DialogContent>
      </Box>

      <DialogActions
        sx={{
          p: 0,
          mt: 3,
          gap: 2,
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{
            flex: 1,
            borderRadius: 50,
            py: 1.5,
            borderColor: theme.palette.divider,
            "&:hover": {
              backgroundColor: alpha(theme.palette.action.hover, 0.05),
              borderColor: theme.palette.text.primary,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            flex: 1,
            borderRadius: 50,
            py: 1.5,
            backgroundColor: "#F97316",
            color: "#ffffff",
            boxShadow: `0 8px 20px ${alpha("#F97316", 0.3)}`,
            "&:hover": {
              backgroundColor: "#EA580C",
              boxShadow: `0 12px 25px ${alpha("#F97316", 0.4)}`,
            },
            "&:active": {
              backgroundColor: "#C2410C",
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
